import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import apiTokenReducer from './apiToken/data/reducer';
import apiTokenSaga, {
  initSaga as apiTokenInitSaga,
} from './apiToken/data/sagas';
import quickbooksReducer from './quickbooks/data/reducer';
import { initSaga as quickbooksInitSaga } from './quickbooks/data/sagas';
import webhookCreateEditDrawerReducer from './webhookCreateEditDrawer/data/reducer';

const initSaga = function* () {
  yield all([apiTokenInitSaga(), quickbooksInitSaga()]);
};

const reducer = combineReducers({
  apiToken: apiTokenReducer,
  quickbooks: quickbooksReducer,
  webhookCreateEditDrawer: webhookCreateEditDrawerReducer,
});

const saga = function* () {
  yield all([apiTokenSaga()]);
};

export { initSaga, reducer, saga };
